import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

function UpdateProfile() {
  const navigate = useNavigate();
  const dealerloginmobile = localStorage.getItem("dealer_login_mobile") || "";
  const server_url = localStorage.getItem("server_url") || "";
  let dealer_id = localStorage.getItem("dealer_id");
  let token = localStorage.getItem("token");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [profile, setProfile] = useState({
    dealer_firm_name: "",
    dealer_login_mobile: dealerloginmobile,
    dealer_order_varification_mobile: "",
    dealer_email: "",
    dealer_address: "",
    dealer_pincode: "",
    dealer_pan_number: "",
    dealer_gst_number: "",
    dealer_id: dealer_id,
    company_id: "2",
    dealer_pan_document: "",
    dealer_gst_document: "",
    dealer_pdc_check: "",
  });

  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    fetchProfileData();

    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line
  }, []);

  const fetchProfileData = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_mobile", dealerloginmobile);

      const response = await axios.post(
        `${server_url}my_profile.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (response.data.status === "1") {
        const userData = response.data.result[0];
        setProfile((prev) => ({
          ...prev,
          ...userData,
        }));
      } else {
        toast.error(response.data.error || "Failed to fetch profile data.");
      }
    } catch (error) {
      toast.error("Network error! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setProfile({ ...profile, [name]: files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      Object.keys(profile).forEach((key) => formData.append(key, profile[key]));

      const response = await axios.post(
        `${server_url}update_profile.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (response.data.status === "1") {
        check_user();
        toast.success("Profile updated successfully!");
      } else {
        toast.error(response.data.error || "Failed to update profile.");
      }
    } catch (error) {
      toast.error("Update failed! Please try again.");
    }
  };

  const check_user = async () => {
    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer_id);
    formData.append("device_token", token);
    await axios
      .post(`${server_url}check_dealer.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((result) => {
        if (result.data.status === "0") {
          navigate("/More");
        } else if (result.data.status === "1") {
          localStorage.setItem(
            "LoginNumber",
            result.data.result[0].dealer_login_mobile,
          );
          localStorage.setItem(
            "local_overdue_amount",
            result.data.result[0].overdue_amount,
          );
          localStorage.setItem(
            "local_dealer_os",
            result.data.result[0].dealer_os,
          );
          localStorage.setItem("order_date", result.data.result[0].order_date);
          localStorage.setItem(
            "local_items_in_cart",
            result.data.result[0].items_in_cart,
          );
          localStorage.setItem(
            "local_current_order_status",
            result.data.result[0].current_order_status,
          );
          localStorage.setItem(
            "local_order_final_total_with_gst",
            result.data.result[0].order_final_total_with_gst,
          );
          localStorage.setItem(
            "local_order_id",
            result.data.result[0].order_id,
          );
          localStorage.setItem(
            "admin_message",
            result.data.result[0].admin_message,
          );
          localStorage.setItem(
            "local_dealer_firm_name",
            result.data.result[0].dealer_firm_name,
          );

          localStorage.setItem("dealer_id", result.data.result[0].dealer_id);
          localStorage.setItem(
            "dealer_firm_name",
            result.data.result[0].dealer_firm_name,
          );
          localStorage.setItem(
            "dealer_order_varification_mobile",
            result.data.result[0].dealer_order_varification_mobile,
          );
          localStorage.setItem(
            "dealer_login_mobile",
            result.data.result[0].dealer_login_mobile,
          );
          localStorage.setItem(
            "dealer_email",
            result.data.result[0].dealer_email,
          );
          localStorage.setItem(
            "dealer_address",
            result.data.result[0].dealer_address,
          );
          localStorage.setItem(
            "dealer_pincode",
            result.data.result[0].dealer_pincode,
          );
          localStorage.setItem(
            "dealer_pan_number",
            result.data.result[0].dealer_pan_number,
          );
          localStorage.setItem(
            "dealer_gst_number",
            result.data.result[0].dealer_gst_number,
          );
          localStorage.setItem("city_name", result.data.result[0].city_name);
          navigate("/More");
        } else {
          navigate("/More");
        }
      });
  };

  const DeleteAccount = () => navigate("/Logout");

  const renderPreview = (fileUrl) => {
    if (!fileUrl) return null;
    const isPdf = fileUrl.toLowerCase().endsWith(".pdf");
    return isPdf ? (
      <div className="file-preview" style={{ borderRadius: "12px" }}>
        <iframe title="PDF Preview" src={fileUrl} className="preview-frame" />
        <div className="file-type-badge">PDF</div>
      </div>
    ) : (
      <div className="file-preview" style={{ borderRadius: "12px" }}>
        <img src={fileUrl} alt="Preview" className="preview-image" />
        <div className="file-type-badge">IMAGE</div>
      </div>
    );
  };

  return (
    <>
      <Header />
      <div className="update-profile-container">
        <div className="profile-card">
          {!isMobile ? (
            <div className="profile-header">
              <h1>Update Profile</h1>
            </div>
          ) : null}
          {loading ? (
            <div className="loading-state">
              <div className="spinner"></div>
              <p>Loading profile data...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="profile-form">
              <div className="form-grid">
                {/* Firm Name */}
                <div className="input-group">
                  <label>Firm Name</label>
                  <input
                    type="text"
                    name="dealer_firm_name"
                    value={profile.dealer_firm_name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter your firm name"
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* Email */}
                <div className="input-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="dealer_email"
                    value={profile.dealer_email}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter your email"
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* Address */}
                <div className="input-group full-width">
                  <label>Business Address</label>
                  <input
                    type="text"
                    name="dealer_address"
                    value={profile.dealer_address}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter your business address"
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* Pincode */}
                <div className="input-group">
                  <label>Pincode</label>
                  <input
                    type="text"
                    name="dealer_pincode"
                    value={profile.dealer_pincode}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter pincode"
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* PAN Number */}
                <div className="input-group">
                  <label>PAN Number</label>
                  <input
                    type="text"
                    name="dealer_pan_number"
                    value={profile.dealer_pan_number}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter PAN number"
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* PAN Document */}
                <div className="input-group ">
                  <label>PAN Document</label>
                  <div className="file-upload-container">
                    <input
                      type="file"
                      name="dealer_pan_document"
                      accept="image/*,application/pdf"
                      onChange={handleFileChange}
                      className="file-input"
                      style={{ borderRadius: "12px" }}
                    />
                    <div className="file-hint">
                      Upload PAN document (Image or PDF)
                    </div>
                  </div>
                  {renderPreview(
                    typeof profile.dealer_pan_document === "string"
                      ? `${profile.dealer_pan_document}`
                      : URL.createObjectURL(profile.dealer_pan_document),
                  )}
                </div>

                {/* GST Number */}
                <div className="input-group">
                  <label>GST Number</label>
                  <input
                    type="text"
                    name="dealer_gst_number"
                    value={profile.dealer_gst_number}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter GST number"
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* GST Document */}
                <div className="input-group ">
                  <label>GST Document</label>
                  <div className="file-upload-container">
                    <input
                      type="file"
                      name="dealer_gst_document"
                      accept="image/*,application/pdf"
                      onChange={handleFileChange}
                      className="file-input"
                      style={{ borderRadius: "12px" }}
                    />
                    <div className="file-hint">
                      Upload GST document (Image or PDF)
                    </div>
                  </div>
                  {renderPreview(
                    typeof profile.dealer_gst_document === "string"
                      ? `${profile.dealer_gst_document}`
                      : URL.createObjectURL(profile.dealer_gst_document),
                  )}
                </div>

                {/* PDC Check */}
                <div className="input-group ">
                  <label>PDC Check Document</label>
                  <div className="file-upload-container">
                    <input
                      type="file"
                      name="dealer_pdc_check"
                      accept="image/*,application/pdf"
                      onChange={handleFileChange}
                      className="file-input"
                      style={{ borderRadius: "12px" }}
                    />
                    <div className="file-hint">
                      Upload PDC check document (Image or PDF)
                    </div>
                  </div>
                  {renderPreview(
                    typeof profile.dealer_pdc_check === "string"
                      ? `${profile.dealer_pdc_check}`
                      : URL.createObjectURL(profile.dealer_pdc_check),
                  )}
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="update-btn">
                  Update Profile
                </button>
                <button
                  type="button"
                  className="delete-btn"
                  onClick={() => setShowDeleteModal(true)}
                >
                  Delete Account
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      {/* Delete Modal */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <i className="fa fa-exclamation-triangle warning-icon"></i>
              <h3>Delete Account</h3>
              <button
                className="modal-close"
                onClick={() => setShowDeleteModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete your account?</p>
              <p className="warning-text">
                This action cannot be undone and all your data will be
                permanently lost.
              </p>
            </div>
            <div className="modal-footer">
              <button
                className="modal-cancel"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button className="modal-confirm" onClick={DeleteAccount}>
                Yes, Delete Account
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .update-profile-container {
          min-height: 100vh;
          background: #ffffff;
          color: #000000;
          font-family:
            -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          padding: 20px 15px;
          padding-top: 80px;
        }

        .profile-card {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
          border: 1px solid #e5e5e5;
          overflow: hidden;
          max-width: 1200px;
          margin: 0 auto;
        }

        .profile-header {
          padding: 30px 25px 20px;
          border-bottom: 1px solid #e5e5e5;
          background: #f8f9fa;
          text-align: center;
        }

        .profile-header h1 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 8px;
          color: #000000;
        }

        .profile-header p {
          color: #666666;
          font-size: 0.95rem;
          margin: 0;
        }

        .profile-form {
          padding: 30px 25px;
        }

        .form-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
          margin-bottom: 30px;
        }

        .input-group {
          display: flex;
          flex-direction: column;
        }

        .input-group.full-width {
          grid-column: 1;
        }

        .input-group label {
          color: #000000;
          font-weight: 600;
          margin-bottom: 8px;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .form-input {
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 12px;
          padding: 14px 16px;
          color: #000000;
          font-size: 16px;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .form-input:focus {
          outline: none;
          border-color: #db4437;
          box-shadow: 0 0 0 3px rgba(219, 68, 55, 0.1);
        }

        .file-upload-container {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .file-input {
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 12px !important;
          padding: 14px 16px;
          color: #000000;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .file-input::-webkit-file-upload-button {
          background: #000000;
          border: none;
          color: #ffffff;
          padding: 10px 16px;
          cursor: pointer;
          margin-right: 12px;
          font-weight: 500;
          transition: background 0.3s ease;
          font-size: 14px;
        }

        .file-input::-webkit-file-upload-button:hover {
          background: #333333;
        }

        .file-hint {
          color: #666666;
          font-size: 12px;
          font-style: italic;
          margin-top: 5px;
        }

        .file-preview {
          position: relative;
          margin-top: 15px;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e5e5e5;
        }

        .preview-frame {
          width: 100%;
          height: 200px;
          border: none;
        }

        .preview-image {
          width: 100%;
          max-height: 200px;
          object-fit: contain;
          background: #f8f9fa;
        }

        .file-type-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          background: rgba(0, 0, 0, 0.8);
          color: white;
          padding: 4px 8px;
          border-radius: 6px;
          font-size: 10px;
          font-weight: 600;
          text-transform: uppercase;
        }

        .form-actions {
          display: flex;
          flex-direction: column;
          gap: 15px;
          padding-top: 30px;
          border-top: 1px solid #e5e5e5;
        }

        .update-btn {
          background: #000000;
          color: white;
          border: none;
          padding: 16px 24px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .update-btn:hover {
          background: #db4437;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(219, 68, 55, 0.2);
        }

        .delete-btn {
          background: transparent;
          color: #ef4444;
          border: 1px solid #ef4444;
          padding: 16px 24px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .delete-btn:hover {
          background: #ef4444;
          color: white;
          transform: translateY(-2px);
        }

        .loading-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 25px;
          color: #000000;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #f0f0f0;
          border-left: 3px solid #db4437;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 20px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
        }

        .modal {
          background: #ffffff;
          border-radius: 20px;
          border: 1px solid #e5e5e5;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
          overflow: hidden;
        }

        .modal-header {
          display: flex;
          align-items: center;
          padding: 25px;
          border-bottom: 1px solid #e5e5e5;
          background: #f8f9fa;
        }

        .modal-header h3 {
          margin: 0;
          color: #000000;
          font-size: 1.3rem;
          font-weight: 600;
        }

        .warning-icon {
          color: #ffa726;
          margin-right: 10px;
          font-size: 1.2rem;
        }

        .modal-close {
          background: none;
          border: none;
          color: #666666;
          font-size: 24px;
          cursor: pointer;
          margin-left: auto;
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: color 0.3s ease;
        }

        .modal-close:hover {
          color: #000000;
        }

        .modal-body {
          padding: 25px;
        }

        .modal-body p {
          margin: 0 0 12px 0;
          color: #000000;
          font-size: 15px;
          line-height: 1.5;
        }

        .warning-text {
          color: #666666 !important;
          font-size: 13px !important;
        }

        .modal-footer {
          display: flex;
          gap: 12px;
          padding: 25px;
          border-top: 1px solid #e5e5e5;
        }

        .modal-cancel {
          flex: 1;
          background: #666666;
          color: white;
          border: none;
          padding: 14px;
          border-radius: 10px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .modal-cancel:hover {
          background: #777777;
        }

        .modal-confirm {
          flex: 1;
          background: #ef4444;
          color: white;
          border: none;
          padding: 14px;
          border-radius: 10px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .modal-confirm:hover {
          background: #dc2626;
        }

        /* Desktop Styles */
        @media (min-width: 768px) {
          .update-profile-container {
            padding: 40px 20px;
            padding-top: 20px;
          }

          .profile-header {
            padding: 40px 50px 30px;
            text-align: left;
          }

          .profile-header h1 {
            font-size: 2.5rem;
            margin-bottom: 12px;
          }

          .profile-header p {
            font-size: 1.1rem;
          }

          .profile-form {
            padding: 50px;
          }

          .form-grid {
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 40px;
          }

          .input-group.full-width {
            grid-column: 1 / -1;
          }

          .form-input {
            padding: 16px 20px;
          }

          .file-input {
            padding: 16px 20px;
          }

          .file-input::-webkit-file-upload-button {
            padding: 12px 20px;
            margin-right: 15px;
          }

          .form-actions {
            flex-direction: row;
            gap: 20px;
            justify-content: center;
            padding-top: 40px;
          }

          .update-btn {
            min-width: 200px;
            padding: 18px 50px;
          }

          .delete-btn {
            min-width: 180px;
            padding: 18px 40px;
          }

          .loading-state {
            padding: 80px 50px;
          }

          .spinner {
            width: 50px;
            height: 50px;
            border-width: 4px;
          }

          .modal {
            max-width: 500px;
          }

          .modal-header {
            padding: 30px;
          }

          .modal-body {
            padding: 30px;
          }

          .modal-footer {
            padding: 30px;
          }
        }

        @media (min-width: 1024px) {
          .form-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
        .file-input,
        .form-input {
          border: 1px solid #e5e5e5 !important;
        }
        .device-card {
          border: 1px solid #e5e5e5 !important;
        }
        .current-device-card {
          border: 1px solid #e5e5e5;
        }
      `}</style>
    </>
  );
}

export default UpdateProfile;
